import React from "react";
import "./MaintenanceOverlay.scss";

const MaintenanceOverlay: React.FunctionComponent<any> = ({ message }) => {
    return (
      <div className="MaintenanceOverlay">
        <div className="message" dangerouslySetInnerHTML={{__html: message}} />
      </div>
    )
}

export default MaintenanceOverlay;
